<button mat-button (click)="openPreviewEmailDialog()">
  {{ 'EMAIL_BUILDER.PAGE.ACTIONS.SEND_PREVIEW_EMAIL' | translate }}
</button>
<button mat-flat-button color="primary" (click)="handleSaveClicked()" [disabled]="saving$ | async">
  <glxy-button-loading-indicator [isLoading]="saving$ | async">
    {{ 'EMAIL_BUILDER.PAGE.ACTIONS.SAVE' | translate }}
  </glxy-button-loading-indicator>
</button>
